import { useLang } from '@/hooks/useLang';

const copy = {
  EN: {
    tag: 'Get Started',
    title: 'Start a Project.',
    sub: 'Tell us your idea. We\'ll handle the rest.',
    cta: 'Start a Project',
    secondary: 'Explore Work',
  },
  TR: {
    tag: 'Başlayın',
    title: 'Proje Başlatın.',
    sub: 'Fikrinizi anlatın. Gerisini biz hallederiz.',
    cta: 'Proje Başlat',
    secondary: 'Çalışmaları Gör',
  },
};

export default function CTASection() {
  const lang = useLang();
  const t = copy[lang];

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-32 bg-gray-900 relative overflow-hidden">
      {/* Subtle gradient */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full opacity-20"
          style={{ background: 'radial-gradient(ellipse, rgba(255,255,255,0.1) 0%, transparent 70%)' }}
        />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-8 md:px-16 text-center">
        <span className="text-xs font-semibold text-white/30 tracking-widest uppercase mb-4 block">{t.tag}</span>
        <h2 className="text-5xl md:text-7xl font-black text-white tracking-tight mb-6" style={{ fontFamily: '\'Space Grotesk\', sans-serif' }}>
          {t.title}
        </h2>
        <p className="text-lg text-white/40 font-light mb-12 max-w-sm mx-auto">{t.sub}</p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
            className="inline-flex items-center justify-center gap-2 px-10 py-4 bg-white text-gray-900 text-sm font-bold tracking-wide rounded-full hover:bg-gray-100 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            {t.cta}
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="#showreel"
            onClick={(e) => { e.preventDefault(); handleNav('#showreel'); }}
            className="inline-flex items-center justify-center gap-2 px-10 py-4 border border-white/20 text-white/70 text-sm font-semibold tracking-wide rounded-full hover:border-white/40 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            {t.secondary}
          </a>
        </div>
      </div>
    </section>
  );
}
